import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CommonDragEndCommand, ComponentDragDropCommand, ComponentDragStartCommand, EntityDragDropCommand, EntityDragMouseDownCommand, EntityDragMouseUpCommand, NodeDragDropCommand, NodeDragStartCommand, SetDragTargetCommand, SidebarDragDropCommand, SidebarDragOverEnterCommand } from '@beefco/sdk-tools/commands';
import { BusSources } from '@beefco/sdk-tools/sources';
import { DragSourceTypes } from '@beefco/types/bridge';
export var DragState = /*#__PURE__*/function () {
  function DragState(bus) {
    var _this = this;
    _classCallCheck(this, DragState);
    this.bus = bus;
    _defineProperty(this, "sourceId", null);
    _defineProperty(this, "sourceType", null);
    _defineProperty(this, "targetId", null);
    _defineProperty(this, "uniqueTargetId", null);
    _defineProperty(this, "targetSide", null);
    _defineProperty(this, "changeTargetTimer", void 0);
    _defineProperty(this, "skipDragEnd", false);
    _defineProperty(this, "isDragging", false);
    bus.on(CommonDragEndCommand, function () {
      _this.isDragging = false;
      _this.sourceId = null;
      _this.sourceType = null;
      _this.skipDragEnd = false;
    });
    bus.on(ComponentDragStartCommand, function (_ref) {
      var componentId = _ref.componentId;
      _this.sourceId = componentId;
      _this.sourceType = DragSourceTypes.COMPONENT;
      _this.isDragging = true;
    });
    bus.on(NodeDragStartCommand, function (_ref2) {
      var nodeId = _ref2.nodeId;
      _this.sourceId = nodeId;
      _this.sourceType = DragSourceTypes.NODE;
      _this.isDragging = true;
    });

    // FIXME: По сути проверять таким образом терпимо, но лучше поискать альтернативы
    if (!this.isPlatformGui()) return;
    bus.on(EntityDragMouseDownCommand, function (_ref3) {
      var nodeId = _ref3.nodeId,
        sourceType = _ref3.sourceType;
      _this.sourceId = nodeId;
      _this.sourceType = sourceType;
    });
    bus.on(SidebarDragDropCommand, function () {
      _this.skipDragEnd = true;
    });
    bus.on(SetDragTargetCommand, function (_ref4) {
      var nodeId = _ref4.nodeId,
        uniqueId = _ref4.uniqueId,
        side = _ref4.side;
      _this.targetId = nodeId;
      _this.uniqueTargetId = uniqueId;
      _this.targetSide = side;
    });
    bus.on(EntityDragDropCommand, function (_ref5) {
      var targetId = _ref5.nodeId,
        side = _ref5.side;
      if (_this.sourceType === DragSourceTypes.COMPONENT) {
        bus.execute(new ComponentDragDropCommand({
          componentId: _this.sourceId,
          targetId: targetId,
          side: side
        }));
      } else {
        bus.execute(new NodeDragDropCommand({
          nodeId: _this.sourceId,
          targetId: targetId,
          side: side
        }));
      }
      _this.resetDrag();
    });
  }
  _createClass(DragState, [{
    key: "emitDragMouseDown",
    value: function emitDragMouseDown(nodeId, sourceType) {
      this.sourceId = nodeId;
      this.bus.execute(new EntityDragMouseDownCommand({
        nodeId: nodeId,
        sourceType: sourceType
      }));
    }
  }, {
    key: "emitDragMouseUp",
    value: function emitDragMouseUp() {
      this.bus.execute(new EntityDragMouseUpCommand(null));
    }
  }, {
    key: "emitComponentDragStart",
    value: function emitComponentDragStart() {
      if (!this.sourceId) return;
      this.isDragging = true;
      this.bus.execute(new ComponentDragStartCommand({
        componentId: this.sourceId
      }));
    }
  }, {
    key: "emitSidebarDrag",
    value: function emitSidebarDrag(_ref6) {
      var x = _ref6.x,
        y = _ref6.y;
      if (!this.sourceId) return;
      this.bus.execute(new SidebarDragOverEnterCommand({
        x: x,
        y: y
      }));
    }
  }, {
    key: "emitSidebarDrop",
    value: function emitSidebarDrop(_ref7) {
      var x = _ref7.x,
        y = _ref7.y;
      if (!this.sourceId) return;
      this.bus.execute(new SidebarDragDropCommand({
        x: x,
        y: y
      }));
    }
  }, {
    key: "emitComponentDragEnd",
    value: function emitComponentDragEnd() {
      if (!this.skipDragEnd) {
        this.resetDrag();
        this.skipDragEnd = false;
      }
    }
  }, {
    key: "resetDrag",
    value: function resetDrag() {
      this.isDragging = false;
      this.sourceId = null;
      this.bus.execute(new CommonDragEndCommand(null));
      this.bus.execute(new SetDragTargetCommand({
        nodeId: null,
        uniqueId: null,
        side: null
      }));
    }
  }, {
    key: "resetDragTarget",
    value: function resetDragTarget() {
      this.bus.execute(new SetDragTargetCommand({
        nodeId: null,
        uniqueId: null,
        side: null
      }));
    }
  }, {
    key: "setDragTarget",
    value: function setDragTarget(_ref8) {
      var nodeId = _ref8.nodeId,
        uniqueId = _ref8.uniqueId,
        side = _ref8.side;
      this.bus.execute(new SetDragTargetCommand({
        nodeId: nodeId,
        uniqueId: uniqueId,
        side: side
      }));
    }
  }, {
    key: "handleNodeDragStart",
    value: function handleNodeDragStart() {
      if (!this.sourceId) return;
      this.isDragging = true;
      this.bus.execute(new NodeDragStartCommand({
        nodeId: this.sourceId
      }));
    }
  }, {
    key: "handleEntityDrop",
    value: function handleEntityDrop(dragDTO) {
      if (!this.isDragging) return;
      this.bus.execute(new EntityDragDropCommand({
        nodeId: dragDTO.nodeId,
        uniqueId: dragDTO.uniqueId,
        side: dragDTO.side
      }));
      this.resetDrag();
    }
  }, {
    key: "handleNodeDragEnd",
    value: function handleNodeDragEnd() {
      var _this2 = this;
      if (!this.skipDragEnd) {
        window.clearTimeout(this.changeTargetTimer);
        this.changeTargetTimer = window.setTimeout(function () {
          return _this2.resetDrag();
        }, 0);
        this.skipDragEnd = false;
      }
    }
  }, {
    key: "handleNodeDrag",
    value: function handleNodeDrag(dragDTO) {
      if (!this.isDragging) return;
      window.clearTimeout(this.changeTargetTimer);
      this.setDragTarget(dragDTO);
    }
  }, {
    key: "handleNodeDragLeave",
    value: function handleNodeDragLeave() {
      var _this3 = this;
      window.clearTimeout(this.changeTargetTimer);
      this.changeTargetTimer = window.setTimeout(function () {
        return _this3.resetDragTarget();
      }, 0);
    }
  }, {
    key: "getIsDragging",
    value: function getIsDragging() {
      return this.isDragging;
    }
  }, {
    key: "isPlatformGui",
    value: function isPlatformGui() {
      return typeof window !== 'undefined' && this.bus.source === BusSources.PLATFORM_GUI;
    }
  }]);
  return DragState;
}();